import { Component, OnInit, TemplateRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal/index';
import { GroupSelectModel } from 'src/app/shared/models/select-model';

@Component({
  selector: 'app-category-modal-list',
  templateUrl: './category-list-modal.component.html',
  styleUrls: ['./category-list-modal.component.scss']
})
export class CategoryListModalComponent implements OnInit {

  categories: GroupSelectModel<number, string>[] = [];

  constructor(
    protected dialogRef: MatDialogRef<ComponentType<any> | TemplateRef<any>>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.categories = data.categories;
  }

  ngOnInit() {

  }

}
